import {
  useState,
  useCallback,
  SetStateAction,
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
  useEffect
} from 'react';
import {
  Drawer,
  TextField,
  Stack,
  Typography,
  Divider,
  Box,
  Grid,
  Tab,
  Tabs,
  Button,
  FormControl,
  MenuItem,
  Alert,
  Snackbar
} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useForm, FormProvider, Controller} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import * as APIService from '@shared/services/service-handlers/PrivateService';
import DialogToolBar from './AdditionData/DialogToolBar';
import {UploadProps} from 'src/minimal-components/upload';
import {RHFCheckbox, RHFSelect} from 'src/minimal-components/hook-form';
import Resources from './AdditionData/Resources';
import NewFilesLockProperties from './AdditionData/NewFilesLockProperties';
import TestCompletionProperties from './TestCompletion';
import AddAssessments from './AddAssessments';
import {FormControlDiv} from '../../module-search-filter/ModuleSearchFilterStyle';
import SelectInput from '@components/form/select-input/SelectInput';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {useAppContext} from '@context/AppContext';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import EncryptUtils from 'src/utils/EncryptUtils';
import LoadingScreen from 'src/minimal-components/loading-screen/loading-screen';
import {LoadingButton} from '@mui/lab';
import {
  OnlineContextProvider,
  useOnlineContext
} from './AdditionData/OnlineTestContext';
import {BASE_RECORD_ID, LMS_IS_ADMIN} from 'src/routes/BaseRoute';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';
const StyledLabel = styled('span')(({theme}) => ({
  ...theme.typography.caption,
  fontSize: '0.9rem',
  flexShrink: 0,
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightSemiBold
}));

// Validation schema using yup
const validationSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  allowed_reattempt_type_id: yup.number().required(),
  allowed_no_of_reattempts_id: yup.number().required(),
  description: yup.string().notRequired(),
  mark_as_mandatory: yup.boolean().nullable().notRequired()
});
interface ModuleData {
  id: string;
  name: string;
  expanded: boolean;
  description?: string;
  duration?: string;
  type: string;
  sequence: number;
  module_lock_type_id?: number;
  locked_until_date?: string;
  Module_Completed?: boolean;
  IsUnlocked?: boolean;
  is_completed?: boolean;
  locked_linked_items?: {
    id: string;
    item_name: string;
    entity_completion_sub_type_id: number;
    module_link_id: number;
    module_id: number;
    type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  }[];
  files?: {
    id: string;
    name: string;
    ParentName: string;
    blob_file_extension?: string;
    fileexpanded: boolean;
    time?: string;
    score?: string;
    lock_type_id: number;
    locked_until_date?: string;
    type: string;
    module_id: number;
    sequence: number;
    ChildItems_Completed?: boolean;
    IsUnlocked?: boolean;
    is_completed?: boolean;
    additionalFiles?: {id: string; name: string}[];
    locked_linked_items?: {
      id: string;
      item_name: string;
      entity_completion_sub_type_id: number;
      module_link_id: number;
      module_id: number;
      type:
        | 'file'
        | 'link'
        | 'content'
        | 'assignment'
        | 'onlinetest'
        | 'module';
    }[];
  }[];
}
interface IKanbanTask {
  id: string;
  name: string;
  AllowReattemptsUntil: number;
  Maximumallowedattempts: number;
  description?: string;
  MarkMandatory?: boolean;
}
interface Propsnew extends Omit<UploadProps, 'file'> {
  multiple?: boolean;
}
interface DropDownData {
  Name: string;
  Values: {label: string; value: number}[];
}
interface Props extends Propsnew {
  task: any;
  uiFieldsdata: any;
  taskDone: any;
  // eslint-disable-next-line react/boolean-prop-naming
  openDetails: boolean;
  onCloseDetails: VoidFunction;
  onUpdateTask?: (updateTask: IKanbanTask) => void;
}

export default function AddOnlineTest({
  task,
  uiFieldsdata,
  openDetails,
  onCloseDetails,
  taskDone,
  onUpdateTask,
  ...other
}: Props) {
  const {
    appState: {applicationName}
  } = useAppContext();
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const {ModulePreviewData, SetModulePreviewData} = useModulePreviewContext();
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const {onlineData, setOnlineData} = useOnlineContext();
  const [lockResourceData, setLockResourceData] = useState<any>();
  const {uiFields, setUiFields} = useOnlineContext();
  // const {dropDowndata, setDropDownData} = useOnlineContext();
  const {dropDownData, setDropDownData} = useModulePreviewContext();
  const [tabActive, setTabsActive] = useState<boolean>(true);
  const [insertedId, setInsertedId] = useState<any>();
  const [saved, setSaved] = useState<boolean>(false);
  const [isloaded, setIsLoaded] = useState<boolean>(false);
  const [onlineLoader, setOnlineLoader] = useState<boolean>(false);
  const [maxattempts, setMaxAttempts] = useState(1);
  const [reattemptUntil, setReattemptUntil] = useState(1);
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      name: onlineData?.name || task?.data?.name || '',
      allowed_reattempt_type_id:
        onlineData?.allowed_reattempt_type_id ||
        task?.data?.allowed_reattempt_type_id ||
        reattemptUntil,
      allowed_no_of_reattempts_id:
        onlineData?.allowed_no_of_reattempts_id ||
        task?.data?.allowed_no_of_reattempts_id ||
        maxattempts,
      description: onlineData?.description || task?.data?.description || '',
      mark_as_mandatory:
        onlineData?.mark_as_mandatory || task?.data?.mark_as_mandatory || false
    }
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const handleChange = (event: any, newValue: SetStateAction<number>) => {
    if (tabActive) {
      setOpenSnackbar(true); // Show the snackbar when `tabActive` is true
    } else {
      setActiveTab(newValue); // Switch tabs
    }
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
    setSaved(false);
  };
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: {errors, isSubmitting}
  } = methods;

  const values = watch();
  const generateOptionsList = (fields: any, data: any) => {
    const transformedData = data
      .map((item: {name: any; id: any}) => ({
        label: item.name,
        value: item.id
      }))
      .sort(
        (a: {sequence: number}, b: {sequence: number}) =>
          a.sequence - b.sequence
      );

    return transformedData;
  };
  const findFileInModule = (
    data: any[],
    moduleId: number,
    fileId: number,
    type: string
  ) => {
    const module = data.find(m => m.id == moduleId);
    if (!module) return null;
    const file = module.files?.find(
      (f: {id: number; type: string}) => f.id == fileId && f.type === type
    );
    return file ?? null;
  };
  const handleLegacyAppChange = async (
    event: any,
    name: string,
    field?: any
  ) => {
    if (uiFields) {
      const {sql_data, order_by, sort_by} = uiFields[name];
      try {
        const data: any = {
          sql_data: sql_data,
          sort: order_by,
          sort_by: sort_by,
          isImportFiles: true
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await APIService.getSearchResultsData(
          applicationName,
          'LMS',
          {
            tk: encryptRequestData
          }
        );
        const new_options = generateOptionsList(
          [{generate_options: true}],
          result?.data
        );
        setDropDownData((prevData: any[]) => {
          const existingEntry = (prevData || []).find(
            (entry: {Name: string}) => entry.Name === name
          );

          if (existingEntry) {
            return prevData || [];
          }

          return [...(prevData || []), {Name: name, Values: new_options}];
        });
        return new_options;
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    } else {
      const {sql_data, order_by, sort_by} = field[name];
      try {
        const data: any = {
          sql_data: sql_data,
          sort: order_by,
          sort_by: sort_by,
          isImportFiles: true
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await APIService.getSearchResultsData(
          applicationName,
          'LMS',
          {
            tk: encryptRequestData
          }
        );
        const new_options = generateOptionsList(
          [{generate_options: true}],
          result?.data
        );
        await setDropDownData((prevData: any[]) => {
          const existingEntry = prevData?.find(
            (entry: {Name: string}) => entry.Name === name
          );

          if (existingEntry) {
            // If the Name already exists, update its Values
            return [...prevData];
          }

          // If the Name is new, add it to the array
          return [...prevData, {Name: name, Values: new_options}];
        });
        return new_options;
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    }
  };
  const init = async () => {
    try {
      setOnlineLoader(true);
      let res;
      if (uiFieldsdata === undefined) {
        res = await APIService.getSearchForm(
          applicationName,
          'module',
          'AddOnlineTest'
        );
        await setUiFields(res.searchForm);
        const hasEntityCompletionType = dropDownData.some(
          item => item.Name === 'AllowedNoofReattemptsId'
        );

        if (!hasEntityCompletionType) {
          await handleLegacyAppChange(
            'AllowedNoofReattemptsId',
            'AllowedNoofReattemptsId',
            res.searchForm
          );
        }
        const hasEntityCompletionTypes = dropDownData.some(
          item => item.Name === 'AllowReattemptsUntil'
        );

        if (!hasEntityCompletionTypes) {
          await handleLegacyAppChange(
            'AllowReattemptsUntil',
            'AllowReattemptsUntil',
            res.searchForm
          );
        }
      } else {
        await setUiFields(uiFieldsdata);
        const hasEntityCompletionType = dropDownData.some(
          item => item.Name === 'AllowedNoofReattemptsId'
        );

        if (!hasEntityCompletionType) {
          await handleLegacyAppChange(
            'AllowedNoofReattemptsId',
            'AllowedNoofReattemptsId',
            uiFieldsdata
          );
        }
        const hasEntityCompletionTypes = dropDownData.some(
          item => item.Name === 'AllowReattemptsUntil'
        );

        if (!hasEntityCompletionTypes) {
          await handleLegacyAppChange(
            'AllowReattemptsUntil',
            'AllowReattemptsUntil',
            uiFieldsdata
          );
        }
      }
      const fileData = findFileInModule(
        ModulePreviewData,
        Number(insertedId?.data[0].module_id),
        Number(insertedId?.data[0].inserted_id),
        insertedId?.data[0].type
      );
      if (fileData) {
        setValue('name', fileData?.name);
        setValue(
          'allowed_reattempt_type_id',
          fileData?.allowed_reattempt_type_id
        );
        setValue(
          'allowed_no_of_reattempts_id',
          fileData?.allowed_no_of_reattempts_id
        );
        setValue('description', fileData?.description);
        setValue('mark_as_mandatory', fileData?.mark_as_mandatory);
        setOnlineData(fileData);
      } else {
        if (task?.data?.id) {
          setValue('name', task?.data?.name);
          setValue(
            'allowed_reattempt_type_id',
            task?.data?.allowed_reattempt_type_id
          );
          setValue(
            'allowed_no_of_reattempts_id',
            task?.data?.allowed_no_of_reattempts_id
          );
          setValue('description', task?.data?.description);
          setValue('mark_as_mandatory', task?.data?.mark_as_mandatory);
          setOnlineData(task?.data);
        } else {
          if (
            (res?.searchForm || uiFieldsdata !== undefined) &&
            (onlineData?.inserted_id || task?.inserted_id)
          ) {
            const {sql_data} =
              uiFieldsdata['create_sql'] || res.searchForm['create_sql'];
            let operations;
            if (onlineData || task) {
              operations = 'SEARCH';
            }
            const data: any = {
              sql_data: sql_data,
              data: {
                id: onlineData?.inserted_id || task?.inserted_id,
                course_overview_id: uniqueId
              },
              operation: operations
            };
            const encryptRequestData = EncryptUtils.encryptedData(data);
            const result = await APIService.getLMSResultsData(
              applicationName,
              'LMS',
              {
                tk: encryptRequestData
              }
            );
            if (result.data[0].allowed_no_of_reattempts_id) {
              // setValue(result.data[0].assignment_submission_type_id);
              setValue(
                'allowed_no_of_reattempts_id',
                result.data[0].allowed_no_of_reattempts_id
              );
              setValue(
                'allowed_reattempt_type_id',
                result.data[0].allowed_reattempt_type_id
              );
              setValue('name', result.data[0].name);
              setValue('description', result.data[0].description);
              setValue('mark_as_mandatory', result.data[0].mark_as_mandatory);
            }
            const transformedResult = result.data.map((item: any) => {
              return {
                ...item,
                ipRestrictions:
                  typeof item?.ipRestrictions === 'string'
                    ? JSON.parse(item.ipRestrictions)
                    : item?.ipRestrictions ?? null,

                entityfiles:
                  typeof item?.entityfiles === 'string'
                    ? JSON.parse(item.entityfiles)
                    : item?.entityfiles ?? null
              };
            });
            setOnlineData(transformedResult[0]);
            setLockResourceData(result);
            setInsertedId(result);
            setOnlineLoader(false);
          }
        }
      }

      setOnlineLoader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setOnlineLoader(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      if (task) {
        setTabsActive(false);
      }
      if (taskDone?.operation === 'INSERT' && insertedId === undefined) {
        setInsertedId(undefined);
      } else if (insertedId !== undefined) {
        setInsertedId(insertedId);
      } else {
        setInsertedId({
          data: [
            {
              module_id: task?.module_id,
              inserted_id: task?.inserted_id,
              type: 'onlinetest'
            }
          ]
        });
      }
      await init();
      // if (taskDone?.operation === 'INSERT') {
      //   setOnlineData(undefined);
      // }
    };

    fetchData();
  }, [activeTab]);
  // Handle removing all files
  const onSubmit = async (datavalue: any) => {
    try {
      if (uiFields) {
        const {sql_data} = uiFields['create_sql'];
        let operations;
        if (taskDone?.id && taskDone?.operation) {
          operations = taskDone?.operation;
          datavalue.module_id = taskDone?.id;
        }
        if (onlineData && onlineData.inserted_id) {
          operations = 'UPDATE';
          datavalue.id = onlineData.inserted_id;
          datavalue.page = 1;
        }
        datavalue.course_overview_id = uniqueId;
        datavalue.isAdmin = lmsisAdmin === 'True';
        datavalue.assessment_show_marks_type_id =
          onlineData?.assessment_show_marks_type_id
            ? onlineData.assessment_show_marks_type_id !== 1 &&
              datavalue?.allowed_no_of_reattempts_id === 11
              ? 5
              : 1
            : null;
        // datavalue.bloburls = datavalue.bloBurls[0].blobUrl;
        setIsLoaded(true);
        const data: any = {
          sql_data: sql_data,
          data: datavalue,
          operation: operations
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await APIService.getLMSResultsData(
          applicationName,
          'LMS',
          {
            tk: encryptRequestData
          }
        );
        const transformedResult = result.data.map((item: any) => {
          return {
            ...item,
            // Parse JSON fields or set them to empty arrays if they are null
            ipRestrictions: item?.ipRestrictions
              ? JSON.parse(item.ipRestrictions)
              : null
            // Add any additional transformations here if needed
          };
        });
        setOnlineData(transformedResult[0]);
        // setLockResourceData(result);
        if (result.data[0]) {
          setLockResourceData({
            data: [{...result.data[0], type: 'onlinetest'}]
          });
          setInsertedId({
            data: [{...result.data[0], type: 'onlinetest'}]
          });
        }
        const processModulesData = (data: ModuleData[]) => {
          return data.map(module => ({
            ...module,
            files:
              module.files?.map(file => ({
                ...file,
                locked_linked_items:
                  typeof file.locked_linked_items === 'string'
                    ? JSON.parse(file.locked_linked_items) // 🛠️ Parse if string
                    : file.locked_linked_items || [], // Keep array or default to empty
                additionalFiles:
                  typeof file.additionalFiles === 'string'
                    ? JSON.parse(file.additionalFiles) // 🛠️ Parse if string
                    : file.additionalFiles || [] // Keep array or default to empty
              })) || []
          }));
        };
        const syncExpandedStates = (
          transformed: ModuleData[],
          existing: ModuleData[]
        ) => {
          return transformed.map(module => {
            const matchingModule = existing.find(e => e.id === module.id);

            if (!matchingModule) return module;

            // Sync the `expanded` flag
            const updatedModule = {
              ...module,
              expanded: matchingModule.expanded || false,
              files:
                module?.files &&
                module?.files.map(file => {
                  const matchingFile =
                    matchingModule?.files &&
                    matchingModule.files.find(f => f.id === file.id);
                  return {
                    ...file,
                    fileexpanded: matchingFile?.fileexpanded || false
                  };
                })
            };

            return updatedModule;
          });
        };

        // Handling API result
        if (result.data[1]) {
          const transformData = await processModulesData(result.data[1]);
          const updatedTransformed = syncExpandedStates(
            transformData,
            ModulePreviewData
          );
          await SetModulePreviewData(updatedTransformed);
          if (insertedId !== undefined) {
            const fileData = findFileInModule(
              updatedTransformed,
              Number(insertedId?.data[0].module_id),
              Number(insertedId?.data[0].inserted_id),
              insertedId?.data[0].type
            );
            if (fileData !== null) {
              setOnlineData(fileData);
            }
          }
        }
        setIsLoaded(false);
        setSaved(true);
        setTabsActive(false);
        setActiveTab(1);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsLoaded(false);
    }
    setTabsActive(false);
  };

  return (
    <FormProvider {...methods}>
      <Drawer
        open={openDetails}
        onClose={() => null}
        // onClose={onCloseDetails}
        anchor="right"
        slotProps={{
          backdrop: {invisible: true}
        }}
        PaperProps={{
          sx: {
            width: {
              xs: 1,
              sm: '75vw'
            },
            top: '60px'
          }
        }}>
        <DialogToolBar
          title={task ? 'Edit Online Test' : 'Add Online Test'}
          onCloseDetails={onCloseDetails}
        />
        <Divider />
        <Box sx={{width: '100%'}}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={activeTab}
                onChange={handleChange}
                variant="fullWidth"
                textColor="primary"
                sx={{
                  backgroundColor: '#F4F6F8',
                  '& .MuiTab-root': {
                    fontSize: '16px',
                    fontWeight: '500',
                    '&:hover': {
                      backgroundColor: '#e0e0e0', // Change background on hover
                      borderRadius: 2
                    }
                  },
                  '& .MuiTab-root.Mui-selected': {
                    color: 'primary.main',
                    margin: 1,
                    backgroundColor: 'white',
                    borderRadius: 2
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#637381',
                    height: 0
                  }
                }}>
                <Tab label="Basic Info" />
                <Tab label="Assessment" disabled={onlineLoader || isloaded} />
                {/* <Tab
                  label="Test Completion"
                  disabled={onlineLoader || isloaded}
                /> */}
                <Tab
                  label="Lock Properties"
                  disabled={onlineLoader || isloaded}
                />
                <Tab label="Resources" disabled={onlineLoader || isloaded} />
              </Tabs>
            </Grid>
          </Grid>
        </Box>
        {activeTab === 0 &&
          (onlineLoader ? (
            <Stack
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              minHeight={'50vh'}>
              <LoadingScreen />
            </Stack>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} style={{overflowY: 'auto'}}>
              <Stack spacing={1.5} sx={{pt: 3, pb: 5, px: 2.5}}>
                {/* Task Name */}
                <Stack spacing={2} direction="column">
                  <StyledLabel>Name</StyledLabel>
                  <Controller
                    name="name"
                    control={control}
                    render={({field}) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                      />
                    )}
                  />
                </Stack>
                <Stack spacing={2} direction="column">
                  <FormControl margin="normal">
                    <Controller
                      name="allowed_no_of_reattempts_id"
                      control={control}
                      render={({field: {value, onChange}}) => (
                        <FormControlDiv>
                          <SelectInput
                            enableDefaultOption
                            name="allowed_no_of_reattempts_id"
                            label="Maximum Allowed Attempts"
                            options={
                              dropDownData?.find(
                                (item: {Name: string}) =>
                                  item.Name === 'AllowedNoofReattemptsId'
                              )?.Values || []
                            }
                            value={value || maxattempts}
                            fullWidth
                            onOpenCallback={(event: any) =>
                              handleLegacyAppChange(
                                event,
                                'AllowedNoofReattemptsId'
                              )
                            }
                            onChange={(event: any) => {
                              onChange(event);
                              setMaxAttempts(Number(event.target.value));
                              // setState(prevState => ({
                              //   ...prevState,
                              //   formError: ''
                              // }));
                            }}
                            optionValueKey={'value'}
                            optionLabelKey={'label'}
                            fetchOptionsFromOnOpenTrigger
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: '30vh', // Set dropdown max height
                                  overflowY: 'auto' // Enable scrolling
                                }
                              }
                            }}
                          />
                        </FormControlDiv>
                      )}
                    />
                  </FormControl>
                </Stack>
                <FormControl margin="normal">
                  {/* <Controller
                    name="AllowReattemptsUntil"
                    control={control}
                    render={({field}) => (
                      <RHFSelect
                        name="AllowReattemptsUntil"
                        label="Allow Reattempts Until"
                        defaultValue="attemptsareavailable"
                        value={field.value}>
                        {SubmissionTypes.map(status => (
                          <MenuItem key={status.value} value={status.value}>
                            {status.label}
                          </MenuItem>
                        ))}
                      </RHFSelect>
                    )}
                  /> */}
                  <Controller
                    name="allowed_reattempt_type_id"
                    control={control}
                    render={({field: {value, onChange}}) => (
                      <FormControlDiv>
                        <SelectInput
                          enableDefaultOption
                          name="allowed_reattempt_type_id"
                          label="Allow Reattempts Until"
                          options={
                            dropDownData?.find(
                              (item: {Name: string}) =>
                                item.Name === 'AllowReattemptsUntil'
                            )?.Values || []
                          }
                          value={value || reattemptUntil}
                          fullWidth
                          onOpenCallback={(event: any) =>
                            handleLegacyAppChange(event, 'AllowReattemptsUntil')
                          }
                          onChange={(event: any) => {
                            onChange(event);
                            setReattemptUntil(Number(event.target.value));
                            // setState(prevState => ({
                            //   ...prevState,
                            //   formError: ''
                            // }));
                          }}
                          optionValueKey={'value'}
                          optionLabelKey={'label'}
                          fetchOptionsFromOnOpenTrigger
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: '30vh', // Set dropdown max height
                                overflowY: 'auto' // Enable scrolling
                              }
                            }
                          }}
                        />
                      </FormControlDiv>
                    )}
                  />
                </FormControl>
                <Stack spacing={2} direction="column">
                  <StyledLabel>Description</StyledLabel>
                  <Controller
                    name="description"
                    control={control}
                    render={({field}) => (
                      <TextField
                        {...field}
                        fullWidth
                        multiline
                        size="small"
                        InputProps={{
                          sx: {
                            typography: 'body2',
                            minHeight: '12vh',
                            alignItems: 'baseline'
                          }
                        }}
                        sx={{minHeight: '12vh'}}
                        error={!!errors.description}
                        helperText={errors.description?.message}
                      />
                    )}
                  />
                </Stack>
                <Stack direction="row">
                  <RHFCheckbox
                    name="mark_as_mandatory"
                    label="Mandatory Assignment"
                  />
                </Stack>

                <Stack display="flex" flexDirection="row-reverse">
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    color="info"
                    loading={isloaded}
                    disabled={isSubmitting}
                    onClick={() => {
                      if (!errors) {
                        onSubmit;
                      }
                    }}>
                    Save
                  </LoadingButton>
                </Stack>
              </Stack>
            </form>
          ))}
        {activeTab === 1 && <AddAssessments />}
        {/* {activeTab === 2 && <TestCompletionProperties />} */}
        {activeTab === 2 && (
          <NewFilesLockProperties
            uiFields={uiFields}
            Moduledata={task?.data ? task.data : undefined}
            insertdata={insertedId}
            tableNameEntity="ModuleOnlineTestSubList"
          />
        )}
        {activeTab === 3 && (
          <Resources
            uiFields={uiFields}
            Moduledata={task?.data ? task.data : undefined}
            insertdata={insertedId}
            tableNameEntity="ContentModuleResourseOnlineTest"
          />
        )}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
          <Alert
            onClose={handleSnackbarClose}
            severity="warning"
            sx={{width: '40vw'}}>
            Basic information data must be added before accessing other tabs.
          </Alert>
        </Snackbar>
        <Snackbar
          open={saved}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{width: '40vw'}}>
            Basic Info is Saved
          </Alert>
        </Snackbar>
      </Drawer>
    </FormProvider>
  );
}
